import React from 'react'

export function GearIcon({ size = 16, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <circle cx="8" cy="8" r="2.25" />
      <path d="M8 1.5v2.25" />
      <path d="M8 12.25v2.25" />
      <path d="M1.5 8h2.25" />
      <path d="M12.25 8h2.25" />
      <path d="M3.4 3.4l1.6 1.6" />
      <path d="M11 11l1.6 1.6" />
      <path d="M3.4 12.6l1.6-1.6" />
      <path d="M11 5l1.6-1.6" />
    </svg>
  )
}
